<template>
  <b-overlay
    :show="show"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <div class="h2 mb-0">
          <b-icon-watch
            font-scale="3"
            animation="cylon"
          />
        </div>
        <h2 class="text-dark">
          Procesando ....
        </h2>
      </div>
    </template>
    <div>
      <b-alert
        variant="primary"
        :show="show"
      >
        <div class="alert-body">
          <span>Acciones</span>
        </div>
      </b-alert>
      <b-card
        no-body
        :show="!show"
      >
        <b-card-header
          class="d-flex justify-content-between align-items-center pt-75 pb-25"
        />

        <b-card-body>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            block
            @click="
              $router.push({
                name: 'home',
              })
            "
          >
            Portal
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-modal.modal-paypal
            variant="primary"
            block
            hidden
          >
            Pagar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-modal.modal-contract-account
            variant="info"
            block
          >
            Estado de Cuenta
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            block
            @click="ot()"
          >
            Orden de Trabajo
          </b-button>
        </b-card-body>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
    BAlert,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BIconWatch,
    BOverlay,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    directives: {
        Ripple,
    },
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        BButton,
        BAlert,
        BOverlay,
        BIconWatch,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem('userData')),
            show: true,
            today: new Date(),
        }
    },
    created() {
        if (typeof this.data !== 'undefined') {
            this.show = false
        }
    },
    methods: {
        ot() {
            this.$root.$emit('bv::show::modal', 'modal-ot')
        },
        saveOt(op, cargo, fecha, nota) {
            this.$http
                .post('ot/', {
                    idcontrato: this.data.idcontrato,
                    idusuario: this.userData.id,
                    idottipo: op,
                    fecha,
                    idotestado: 'PE',
                    nota_1: nota,
                    cargo,
                })
                .then((response) => {
                    const {msn} = response.data

                    this.show = false

                    if (msn === 'SI') {
                        this.$swal({
                            title: 'OT Generada Correctamente',
                            text: '',
                            icon: 'success',
                            customClass: {
                                confirmButton: 'btn btn-primary',
                            },
                            buttonsStyling: false,
                        }).then((result) => {
                            if (result.value) {
                                this.$router.go()
                            }
                        })
                    } else {
                        const {error} = response.data
                        this.$swal({
                            title: 'Error',
                            text: error,
                            icon: 'error',
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
                .catch((error) => {
                    this.show = false
                    this.showToast(error.message, 'danger', 'IconClose')
                })
        },
        showToast(message, variant, icon) {
            this.$toast({
                title: message,
                variant,
                icon,
            })
        },
    },
}
</script>

<style></style>
